<template>
  <BuilderWrapper
    title="Display Names"
    helpful-tip="Change the names displayed in the popup for each geometry"
  >
    <FilterSearch
      v-model="search"
      @clear="search = ''"
    />
    <b-table
      id="geomconf-table"
      :fields="fields"
      :items="items"
      responsive
      bordered
      small
      :filter="search"
    >
      <template v-slot:cell(id)="data">
        <b-input
          v-model="data.item.id"
          size="sm"
          disabled
          :state="state(data.value)"
        />
      </template>
      <template v-slot:cell(label)="data">
        <b-input
          v-model="data.item.label"
          size="sm"
          :state="state(data.value)"
          @input="valueChanged(data.item, $event)"
        />
      </template>
    </b-table>
  </BuilderWrapper>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import FilterSearch from '@/components/common/FilterSearch.vue'

const components = {
  BuilderWrapper,
  FilterSearch,
}

@Component({ components })
export default class GeometryAlias extends Vue {
  search = ''

  get geomConfig () {
    return this.$typedStore.primary.app.config.geomConfig ?? {}
  }

  get items () {
    return Object.keys(this.geomConfig).map(key => {
      return {
        id: key,
        label: this.geomConfig[key],
      }
    })
  }

  get fields () {
    return [
      { key: 'id', label: 'Unique ID' },
      { key: 'label', label: 'Name' },
    ]
  }

  state (value: any) {
    return value ? null : false
  }

  valueChanged (item: any, value: any) {
    this.$typedStore.primary.app.updateConfig({
      configPath: ['geomConfig', item.id],
      value: value,
    })
  }
}

</script>

<style>

#geomconf-table td {
  padding: 0;
}

</style>
